import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e8fcfaba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "modal" }
const _hoisted_2 = { class: "custom-modal" }
const _hoisted_3 = {
  key: 0,
  class: "modal-message"
}
const _hoisted_4 = {
  key: 1,
  class: "modal-message"
}
const _hoisted_5 = { class: "modal-buttons" }

import { ComputedRef, computed, toRefs, withDefaults, onUnmounted } from 'vue'

  import { ROOT_STORE } from '@/store/constants'
  import { useStore } from '@/use/useStore'

  interface Props {
    title: string
    message: string
    strongMessage?: string | null
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    message: null,
    strongMessage: { default: () => null }
  },
  emits: ['cancelAction', 'confirmAction'],
  setup(__props: any, { emit }) {

const props = __props as { title: string, message: string, strongMessage: string | null }

  

  

  const store = useStore()

  const { title, message, strongMessage } = toRefs(props)
  const errorMessages: ComputedRef<string | string[] | null> = computed(
    () => store.getters[ROOT_STORE.GETTERS.ERROR_MESSAGES]
  )
  onUnmounted(() => store.commit(ROOT_STORE.MUTATIONS.EMPTY_ERROR_MESSAGES))

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Card, null, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(title)), 1)
        ]),
        content: _withCtx(() => [
          (_unref(strongMessage))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_i18n_t, { keypath: _unref(message) }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_unref(strongMessage)), 1)
                  ]),
                  _: 1
                }, 8, ["keypath"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(message)), 1)),
          (_unref(errorMessages))
            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                key: 2,
                message: _unref(errorMessages)
              }, null, 8, ["message"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            (!_unref(errorMessages))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "confirm",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('confirmAction')))
                }, _toDisplayString(_ctx.$t('buttons.YES')), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "cancel",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('cancelAction')))
            }, _toDisplayString(_ctx.$t(`buttons.${_unref(errorMessages) ? 'CANCEL' : 'NO'}`)), 1)
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})